import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

/**
 * Fetch news articles via the backend proxy
 * @param {string} language - Language code ('en' or 'hi')
 * @returns {Promise<Array>} News articles
 */
const fetchNewsFromProxy = async (language = 'en') => {
  try {
    const query =
      language === 'en' ? 'Ayodhya Ram Mandir' : 'अयोध्या राम मंदिर';

    const response = await axios.get(`${API_BASE_URL}/news`, {
      params: { q: query },
    });

    const articles = response.data?.articles || [];
    return articles.map((article) => ({
      title: article.title,
      description: article.description,
      url: article.url,
      publishedAt: article.publishedAt,
      source: { name: article.source?.name },
    }));
  } catch (error) {
    console.error('Error fetching news from proxy:', error);
    return [];
  }
};

/**
 * Fetch news articles
 * @param {string} language - Language code ('en' or 'hi')
 * @returns {Promise<Array>} News articles
 */
export const fetchNews = async (language = 'en') => {
  try {
    const newsResults = await fetchNewsFromProxy(language);
    return newsResults;
  } catch (error) {
    console.error('Error fetching news:', error);
    return [];
  }
};
